export const config = {
  getPiralBackendUrl: () => {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname;
      // Check if host matches the pattern "app.*.*.olive-team.com"
      const appOliveRegex = /^app\..+\.olive-team\.com$/;

      if (appOliveRegex.test(host)) {
        return `https://${host}/`;
      }
    }

    // Fallback to existing logic
    const sandbox: string = 'dev';
    
    //@ts-ignore gets filled during deployment
    if (!sandbox.startsWith('$')) {
      if(sandbox === 'dev')
      {
        return 'https://api.olive-team.com/piral/'
      }
      return `https://api.${sandbox}.olive-team.com/piral/`;
    } else {
      return './';
    }
  },

  getDataLayerUrl: () => {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname;
      const appOliveRegex = /^app\..+\.olive-team\.com$/;

      if (appOliveRegex.test(host)) {
        const domainParts = host.split('.');
        domainParts[0] = 'api';
        const newHost = domainParts.join('.');
        return `https://${newHost}/data-layer/`;
      }
    }

    // Fallback to existing logic
    const sandbox: string = 'dev';
    //@ts-ignore gets filled during deployment

    if (!sandbox.startsWith('$')) {
      if(sandbox === 'dev')
      {
        return 'https://api.olive-team.com/data-layer/'
      }
      return `https://api.${sandbox}.olive-team.com/data-layer/`;
    } else {
      return 'https://develop.cloud.omilab.org/api/data-layer/';
    }
  },
};
